import { render, staticRenderFns } from "./MMP_DatasetSelection.vue?vue&type=template&id=b962ef0a&scoped=true&"
import script from "./MMP_DatasetSelection.vue?vue&type=script&lang=js&"
export * from "./MMP_DatasetSelection.vue?vue&type=script&lang=js&"
import style0 from "./MMP_DatasetSelection.vue?vue&type=style&index=0&id=b962ef0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b962ef0a",
  null
  
)

export default component.exports